module.exports = __webpack_public_path__ + "static/media/Avatars_Male-28.805cfaab.png";